import { ReportedProblemsStorage } from "../../utils/ReportedProblemsStorage"

import { ViewMode } from "utils/interfaces"
import { useSearchParams } from "utils/customHooks"
import { buildHashIdsQuery } from "utils/helpers"
import { APP_STATUSES } from "utils/AppStatusContext"
import { useQueryContext } from "utils/hooks"
import { Layout } from "components"
import { SelectionOfPsychologists } from "modules/SelectionOfPsychologists"

export function PsychologistListPage() {
    const searchParams = useSearchParams()
    const hashIds = searchParams.get("hash_ids") || ""
    const reportedProblems = searchParams.get("reported_problems") || ""
    const reportedProblemsA = reportedProblems ? reportedProblems.split(",").map((i) => +i) : []

    if (reportedProblemsA.length > 0)
        ReportedProblemsStorage.store({
            reported_problems_id: reportedProblemsA,
        })

    const mode = (
        searchParams.get("email_source") === "competence_questionnaire"
            ? APP_STATUSES.results_from_email
            : APP_STATUSES.list
    ) as ViewMode
    const query = buildHashIdsQuery({
        hashIds: hashIds.split(","),
        resultsKey: searchParams.get("results_key") as string,
        source: {
            mode,
            search_terms: {},
        },
        publicServicesOnly: true,
    })

    const [{ response }] = useQueryContext(query)

    return (
        <Layout isLoading={!response}>
            {response && (
                <SelectionOfPsychologists profiles={response.profiles} showPsysStory={1} />
            )}
        </Layout>
    )
}
